import * as React from "react";
import OrderDetailButtonStatus from "./OrderDetailButtonStatus";


interface Data {
  orderStatus: any;
}

class status extends React.Component<Data> {
  state = {

  };

  constructor(props: Data) {
    super(props);
    console.log(this.props.orderStatus);
  }

  render() {
    return (
      <div className='order-status'>
         <label>订单状态：</label>
         <span>{this.props.orderStatus.status}</span>
         <div className='sub-box'>
            {/* 状态按钮组 */}
            <OrderDetailButtonStatus Status={this.props.orderStatus}/>
         </div>
      </div> 
    );
  }
}


export default status;
